// 渠道导航配置：Boss / 猎聘 / 智联 各含 3 个二级设置；运营为单页
export const channels = [
  {
    key: 'boss',
    label: 'Boss',
    icon: 'el-icon-s-platform',
    children: [
      { key: 'task', label: '任务中心' },
      { key: 'greet', label: '招呼设置' },
      { key: 'chat', label: '聊天设置' },
      { key: 'rechat', label: '复聊设置' }
    ]
  },
  {
    key: 'liepin',
    label: '猎聘',
    icon: 'el-icon-s-platform',
    children: [
      { key: 'task', label: '任务中心' },
      { key: 'greet', label: '招呼设置' },
      { key: 'chat', label: '聊天设置' },
      { key: 'rechat', label: '复聊设置' }
    ]
  },
  {
    key: 'zhilian',
    label: '智联',
    icon: 'el-icon-s-platform',
    children: [
      { key: 'task', label: '任务中心' },
      { key: 'greet', label: '招呼设置' },
      { key: 'chat', label: '聊天设置' },
      { key: 'rechat', label: '复聊设置' }
    ]
  },
  {
    key: 'log',
    label: '运行日志',
    icon: 'el-icon-s-help',
    children: []
  },
  {
    key: 'ats',
    label: '智猎ATS',
    icon: 'el-icon-s-order',
    children: []
  }
]

export function findRoute(channelKey, typeKey) {
  const ch = channels.find(c => c.key === channelKey)
  if (!ch) return null
  if (typeKey) {
    const t = ch.children.find(t => t.key === typeKey)
    if (t) return { channel: ch, type: t, title: `${ch.label} · ${t.label}` }
  }
  return { channel: ch, type: null, title: ch.label }
}
